module.exports = __webpack_public_path__ + "static/media/man-with-cane.3e0967f6.png";